"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const AppSearchInout = (0, react_1.forwardRef)((_a, ref) => {
    var { autoCompleteData, value: externalValue, onChange, onEnter } = _a, props = __rest(_a, ["autoCompleteData", "value", "onChange", "onEnter"]);
    const refAutoCompleteContainer = (0, react_1.useRef)(null);
    const [isOpenAutoComplete, setIsOpenAutoComplete] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)();
    const [rows, setRows] = (0, react_1.useState)(1);
    const [textAreaScrollHeight, setTextAreaScrollHeight] = (0, react_1.useState)(38);
    const [visualContainerHeight, setVisualContainerHeight] = (0, react_1.useState)(0);
    const handleClickOutside = (event) => {
        if (refAutoCompleteContainer.current && !refAutoCompleteContainer.current.contains(event.target)) {
            setIsOpenAutoComplete(false);
        }
    };
    const textareaRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (externalValue !== value) {
            setValue(externalValue);
        }
    }, [externalValue, value]);
    (0, react_1.useEffect)(() => {
        if (isOpenAutoComplete) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpenAutoComplete]);
    const handleClickInput = () => {
        setIsOpenAutoComplete(true);
    };
    const handleClickItem = (item) => {
        const { value } = item;
        internalChange(value);
        setTimeout(() => {
            adjustTextHeight();
        }, 10);
        setIsOpenAutoComplete(false);
    };
    const internalChange = (value) => {
        setValue(value);
        if (onChange && typeof onChange === 'function')
            onChange(value);
    };
    const adjustTextHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.rows = 1; // Reseta para evitar que o `scrollHeight` fique travado
            textarea.rows = Math.floor(textarea.scrollHeight / 23);
            setTextAreaScrollHeight(Math.max(textarea.scrollHeight, 38));
        }
    };
    const handleChange = (e) => {
        const { value } = e.target;
        adjustTextHeight();
        internalChange(value);
    };
    const handleClickIcon = () => {
        if (value != null && value.trim() !== "") {
            internalChange("");
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            setIsOpenAutoComplete(false);
            if (onEnter && typeof onEnter === 'function') {
                onEnter();
            }
        }
    };
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            adjustTextHeight();
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [textareaRef.current]);
    (0, react_1.useEffect)(() => {
        let timeOut = null;
        if (textareaRef.current) {
            timeOut = setTimeout(() => {
                adjustTextHeight();
            }, 100);
        }
        return () => {
            if (timeOut != null)
                clearTimeout(timeOut);
        };
    }, [autoCompleteData, externalValue, onChange, props]);
    (0, react_1.useEffect)(() => {
        if (isOpenAutoComplete && (autoCompleteData === null || autoCompleteData === void 0 ? void 0 : autoCompleteData.length) > 0 && (refAutoCompleteContainer === null || refAutoCompleteContainer === void 0 ? void 0 : refAutoCompleteContainer.current)) {
            setVisualContainerHeight(refAutoCompleteContainer === null || refAutoCompleteContainer === void 0 ? void 0 : refAutoCompleteContainer.current.clientHeight);
        }
        else {
            setVisualContainerHeight(0);
        }
    }, [autoCompleteData, isOpenAutoComplete, refAutoCompleteContainer]);
    // @ts-ignore
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(styles_1.TextInput, Object.assign({}, props, { onKeyDown: handleKeyDown, className: "b-tema20 cortxt foco", rows: 1, ref: (el) => {
                // @ts-ignore
                textareaRef.current = el;
                if (typeof ref === "function")
                    ref(el);
                else if (ref) {
                    ref.current = el;
                }
            }, value: value, onChange: handleChange, onClick: handleClickInput })),
        // eslint-disable-next-line no-nested-ternary
        value != null && value.trim() !== "" && !isOpenAutoComplete ? (react_1.default.createElement(styles_1.IconContainer, { style: { cursor: 'pointer' }, onClick: handleClickIcon },
            react_1.default.createElement(styles_1.InputIcon, { icon: free_solid_svg_icons_1.faTimes }))) : isOpenAutoComplete && autoCompleteData && autoCompleteData.length > 0 ? (react_1.default.createElement(styles_1.IconContainer, null,
            react_1.default.createElement(styles_1.InputIcon, { icon: free_solid_svg_icons_1.faAngleUp }))) : (react_1.default.createElement(styles_1.IconContainer, null)),
        isOpenAutoComplete && autoCompleteData && autoCompleteData.length > 0 ? (react_1.default.createElement(styles_1.AutoComplete
        //@ts-ignore
        , { 
            //@ts-ignore
            top: `${(textAreaScrollHeight) + 2}px`, ref: refAutoCompleteContainer },
            react_1.default.createElement(styles_1.AutoCompleteList, null, autoCompleteData.map((item, index) => (react_1.default.createElement(styles_1.AutoCompleteItem, { onClick: e => handleClickItem(item), key: item.key }, item.value)))))) : '',
        react_1.default.createElement(styles_1.VisualContainer, { style: {
                height: visualContainerHeight + textAreaScrollHeight,
            } })));
});
AppSearchInout.displayName = "AppSearchInout";
exports.default = AppSearchInout;
